import $ from "jquery";
import {ajax} from "./utils";
import {throttle, hasOwn} from "./framework/voidash";

const data = {};

function ensureContext(context) {
  if(hasOwn(data, context)) return;

  const str = $(`[data-context='${context}'][data-context-storage]`).attr("data-context-storage");
  if(str) {
    try {
      data[context] = JSON.parse(str);
    } catch (e) {
      console.error("Invalid data for context: " + context, e);
      data[context] = {};
    }
  } else {
    console.debug("No data for context: " + context);
    data[context] = {};
  }
}

const submit = throttle(context => {
  ajax({
    url: "?ajax=savecontextdata&ajaxContext=" + context,
    method: "post",
    data: "&act=savecontext&data=" + encodeURIComponent(JSON.stringify(data[context]))
  });
}, 500);

export const ContextStorage = {
  set(context, key, value) {
    ensureContext(context);
    data[context][key] = value;
    submit(context);
  },

  get(context, key) {
    ensureContext(context);
    return data[context][key];
  }
};
